import { API_BASE as BASE } from '../lib/env';

export interface SessionListItem {
  sessionId: string;
  startedAt: string;
  endedAt: string;
  pointCount: number;
  distanceM: number;
  avgRsrp: number | null;
}

export interface SessionMeasurementRow {
  ts: string | null;
  lat: number | null;
  lon: number | null;
  rsrp: number | null;
  rsrq: number | null;
  sinr: number | null;
  ci: number | string | null;
  pci: number | null;
  tac: number | null;
  earfcn: number | null;
  networkGeneration: string | null;
  timingAdvance: number | null;
  mcc: string | null;
  mnc: string | null;
  downloadMbps: number | null;
  uploadMbps: number | null;
  latencyMs: number | null;
  mos: number | null;
  operator: string | null;
}

export interface SessionPath {
  type: 'FeatureCollection';
  features: Array<{ type: 'Feature'; geometry: { type: 'LineString'; coordinates: [number, number][] }; properties: Record<string, unknown> }>;
  summary: {
    sessionId?: string;
    pointCount: number;
    distanceM: number;
    durationMs?: number;
    startedAt?: string;
    endedAt?: string;
    bbox?: unknown;
  };
}

export async function listSessions(): Promise<SessionListItem[]> {
  const r = await fetch(`${BASE}/sessions`);
  if (!r.ok) throw new Error(`/sessions ${r.status}`);
  return r.json();
}

export async function fetchSessionPath(sessionId: string): Promise<SessionPath> {
  const r = await fetch(`${BASE}/sessions/${encodeURIComponent(sessionId)}/path`);
  if (!r.ok) throw new Error(`/sessions/${sessionId}/path ${r.status}`);
  return r.json();
}

export async function fetchSessionMeasurements(sessionId: string): Promise<SessionMeasurementRow[]> {
  const r = await fetch(`${BASE}/sessions/${encodeURIComponent(sessionId)}/measurements`);
  if (!r.ok) throw new Error(`/sessions/${sessionId}/measurements ${r.status}`);
  return r.json();
}
